import { jsx } from 'react/jsx-runtime';
import { useState, useEffect } from 'react';
import clsx from 'clsx';
import { fillStyle } from './swatch.utils.js';
import { paint, host, size, shape, padding, fill, custom, image } from './swatch.css.js';

/**
 * Host class names for size and shape. Padding grows the host past the paint to give an
 * interaction target, so it is opt-in and only `SwatchButton` asks for it.
 */
function hostClassName(size$1, shape$1, padding$1 = false) {
    return clsx(host, size[size$1], shape[shape$1], padding[String(padding$1)]);
}
/** Internal paint content in the swatch. */
function Paint({ fill }) {
    return (jsx("span", { "data-fpl-component": "", "aria-hidden": "true", className: paint, "data-swatch-paint": "", children: jsx(SwatchFillContent, { fill: fill }) }));
}
Paint.displayName = 'Paint';
function SwatchFillContent({ fill: fill$1 }) {
    if (fill$1.type === 'image') {
        return jsx(SwatchImageFill, { "data-fpl-component": "", src: fill$1.src });
    }
    if (fill$1.type === 'custom') {
        return (jsx("span", { "data-fpl-component": "", "aria-hidden": "true", className: clsx(fill, custom), "data-swatch-fill": "", children: fill$1.content }));
    }
    return (jsx("span", { "data-fpl-component": "", "aria-hidden": "true", className: fill, "data-swatch-fill": "", style: fillStyle(fill$1) }));
}
SwatchFillContent.displayName = 'SwatchFillContent';
function SwatchImageFill({ src }) {
    const [loadedSrc, setLoadedSrc] = useState(null);
    useEffect(() => {
        setLoadedSrc(null);
    }, [src]);
    return (jsx("img", { "data-fpl-component": "", alt: "", "aria-hidden": "true", className: clsx(fill, image), "data-loaded": loadedSrc === src, "data-swatch-fill": "", draggable: false, src: src, onError: () => setLoadedSrc(null), onLoad: () => setLoadedSrc(src) }));
}
SwatchImageFill.displayName = 'SwatchImageFill';

export { Paint, hostClassName };
//# sourceMappingURL=swatch-paint.js.map
